import { useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';

const WHATSAPP = '2349115294976';

const PLANS = [
  {
    id: 'starter',
    name: 'Starter Plan',
    priceUSD: '$49', priceNGN: '₦78,400',
    period: '/month',
    color: '#6366f1',
    badge: '⭐ Most Popular',
    features: [
      'Everything in Free',
      'Smart Setup Wizard',
      'Full Campaign Builder',
      'AI keywords & ad copy generator',
      'Click-by-click Launch Guide',
      'Results tracking & insights',
      'Unlimited campaigns',
    ],
  },
  {
    id: 'pro',
    name: 'Pro Plan',
    priceUSD: '$99', priceNGN: '₦158,400',
    period: '/month',
    color: '#7c3aed',
    badge: null,
    features: [
      'Everything in Starter',
      'YouTube Ads campaign builder',
      'Full template library',
      'Industry keyword packs',
      'Landing page templates',
      'AI optimisation suggestions',
      'Priority support',
    ],
  },
  {
    id: 'premium',
    name: 'Premium Package',
    priceUSD: '$300', priceNGN: '₦480,000',
    period: ' one-time',
    color: '#059669',
    badge: '🏆 Done For You',
    features: [
      'Full Google Ads account setup',
      'Complete campaign build & launch',
      'Landing page creation',
      'GTM conversion tracking setup',
      'Campaign optimisation',
      '1-on-1 strategy call',
      'Dedicated campaign manager',
    ],
  },
];

export default function Upgrade() {
  const navigate = useNavigate();

  const handlePlan = (plan) => {
    if (plan.id === 'premium') {
      const msg = encodeURIComponent(
        `Hello PilotLeadGen! I am interested in the Premium Package ($300 one-time). I would like to book a call.`
      );
      window.open(`https://wa.me/${WHATSAPP}?text=${msg}`, '_blank');
      return;
    }
    // Go to /plans with upgrade flag — hides free plan, shows payment directly
    navigate('/plans?upgrade=true');
  };

  return (
    <div style={s.page}>
      {/* Header */}
      <div style={s.header}>
        <Logo size={34} showText={true} textSize={16} />
      </div>

      {/* Hero */}
      <div style={s.hero}>
        <div style={s.badge}>🔒 Premium Feature</div>
        <h1 style={s.title}>Upgrade to Build Your Campaign</h1>
        <p style={s.sub}>
          You're on the free plan. Upgrade to unlock the full campaign builder,
          AI keywords, ad copy generator and click-by-click launch guide.
        </p>
      </div>

      {/* Plan cards */}
      <div style={s.grid}>
        {PLANS.map(plan => (
          <div key={plan.id} style={{
            ...s.card,
            borderColor: plan.badge ? plan.color : '#e2e8f0',
            boxShadow:   plan.badge ? `0 8px 32px ${plan.color}25` : '0 2px 12px rgba(0,0,0,0.05)',
            transform:   plan.id === 'starter' ? 'scale(1.03)' : 'scale(1)',
          }}>
            {plan.badge && (
              <div style={{ ...s.planBadge, background: plan.color }}>{plan.badge}</div>
            )}

            <div style={s.planName}>{plan.name}</div>
            <div style={s.priceRow}>
              <span style={{ ...s.price, color: plan.color }}>{plan.priceUSD}</span>
              <span style={s.period}>{plan.period}</span>
            </div>
            <div style={{ fontSize:12, color:'#94a3b8', fontFamily:'sans-serif', marginBottom:16 }}>
              or {plan.priceNGN} for Nigerian users
            </div>
            <div style={s.divider} />

            <div style={s.features}>
              {plan.features.map((f, i) => (
                <div key={i} style={s.featureRow}>
                  <span style={{ ...s.tick, color: plan.color }}>✓</span>
                  <span style={s.featureTxt}>{f}</span>
                </div>
              ))}
            </div>

            <button
              style={{ ...s.btn, background: `linear-gradient(135deg,${plan.color},${plan.color}cc)` }}
              onClick={() => handlePlan(plan)}
            >
              {plan.id === 'premium' ? 'Book a Call →' : `Get ${plan.name} →`}
            </button>

            {plan.id === 'premium' && (
              <div style={{ textAlign:'center', fontSize:12, color:'#64748b', fontFamily:'sans-serif', marginTop:10 }}>
                📞 WhatsApp: +{WHATSAPP}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Reassurance */}
      <div style={s.reassure}>
        {[['🔒','Secure payments — Paystack, Korapay & Flutterwave'],['↩️','Cancel anytime'],['💬','Support via WhatsApp & email']].map(([icon, text], i) => (
          <div key={i} style={{ display:'flex', alignItems:'center', gap:8 }}>
            <span>{icon}</span>
            <span style={{ fontSize:13, color:'#64748b', fontFamily:'sans-serif' }}>{text}</span>
          </div>
        ))}
      </div>

      <button style={s.backBtn} onClick={() => navigate(-1)}>← Go Back</button>
    </div>
  );
}

const s = {
  page:      { minHeight:'100vh', background:'linear-gradient(160deg,#f8faff,#eef2ff)', paddingBottom:60, fontFamily:"'Georgia',serif" },
  header:    { display:'flex', alignItems:'center', justifyContent:'center', padding:'20px 24px', background:'#fff', borderBottom:'1px solid #e2e8f0' },
  hero:      { textAlign:'center', maxWidth:580, margin:'0 auto', padding:'40px 24px 28px' },
  badge:     { display:'inline-block', fontSize:12, fontWeight:700, color:'#6366f1', background:'#eef2ff', border:'1px solid #c7d2fe', padding:'5px 14px', borderRadius:20, fontFamily:'sans-serif', marginBottom:16 },
  title:     { fontSize:28, fontWeight:800, color:'#0f172a', marginBottom:12, lineHeight:1.2 },
  sub:       { fontSize:15, color:'#64748b', fontFamily:'sans-serif', lineHeight:1.65 },
  grid:      { display:'flex', gap:20, justifyContent:'center', flexWrap:'wrap', maxWidth:1100, margin:'0 auto', padding:'0 20px 32px' },
  card:      { flex:'1 1 280px', maxWidth:340, background:'#fff', borderRadius:20, border:'2px solid', padding:'32px 24px', position:'relative', display:'flex', flexDirection:'column' },
  planBadge: { position:'absolute', top:-13, left:'50%', transform:'translateX(-50%)', color:'#fff', fontSize:11, fontWeight:800, padding:'4px 16px', borderRadius:20, fontFamily:'sans-serif', whiteSpace:'nowrap' },
  planName:  { fontSize:13, fontWeight:700, color:'#94a3b8', fontFamily:'sans-serif', textTransform:'uppercase', letterSpacing:1, marginBottom:8 },
  priceRow:  { display:'flex', alignItems:'baseline', gap:4, marginBottom:4 },
  price:     { fontSize:40, fontWeight:800, fontFamily:'sans-serif', lineHeight:1 },
  period:    { fontSize:15, color:'#94a3b8', fontFamily:'sans-serif' },
  divider:   { height:1, background:'#f1f5f9', margin:'16px 0' },
  features:  { display:'flex', flexDirection:'column', gap:10, flex:1, marginBottom:20 },
  featureRow:{ display:'flex', alignItems:'flex-start', gap:10 },
  tick:      { fontWeight:700, flexShrink:0, fontSize:14, marginTop:2 },
  featureTxt:{ fontSize:13, color:'#475569', fontFamily:'sans-serif', lineHeight:1.4 },
  btn:       { width:'100%', padding:'14px', borderRadius:12, color:'#fff', border:'none', fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:'sans-serif', boxShadow:'0 4px 16px rgba(0,0,0,0.1)' },
  reassure:  { display:'flex', justifyContent:'center', gap:32, flexWrap:'wrap', padding:'16px 24px 24px', maxWidth:700, margin:'0 auto' },
  backBtn:   { display:'block', margin:'8px auto 0', background:'none', border:'none', fontSize:14, color:'#6366f1', fontWeight:600, cursor:'pointer', fontFamily:'sans-serif' },
};